<template lang="pug">
table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
  thead.thead-light
    tr
      th.text-center(width="5%")
        span #
      th(width="7%")
        span(:title="$t('ui.domain_name')") {{ $t('ui.domain_name') }}
      th(width="7%")
        span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
      th.text-center(width="7%")
        span(:title="$t('ui.count')") {{ $t('ui.count') }}
  tbody.clusterize-content
    tr(v-if="tbl.length == 0")
      td(colspan="4").text-center
        span {{ $t('message.no_data_available') }}
    tr(v-for="(item, index) in tbl")
      td.text-center
        span(:title="index + 1") {{ index + 1 }}
      td
        span(:title="item.domain_name") {{ item.domain_name }}&nbsp;
      td
        span(:title="item.amount") {{ item.amount }}&nbsp;
      td
        span(:title="item.count") {{ item.count }}&nbsp;
</template>

<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
  },
  data: () => ({
    loading: false
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
  },

  mounted: function() {},
  methods: {}
};
</script>